// Add your custom JS here.

(function($, apiEndpoint) {
    
    /**
     * HANDLE REAL VH (remove height of browsers bars)
     */
    var vh = window.innerHeight * 0.01;
    document.body.style.setProperty('--prlb-vh', `${vh}px`);
    $(window).on('resize', function() {
        var vh = window.innerHeight * 0.01;
        document.body.style.setProperty('--prlb-vh', `${vh}px`);
    });

    /**
     * Toggle the icon's navbar toggler
     */
    document.addEventListener('DOMContentLoaded', function() {
        const offcanvasMenuMobile = document.getElementById('offcanvasRightMobile'),
            wrapperMenuToggler = document.querySelector('.wrapper-menu');

        if( offcanvasMenuMobile && wrapperMenuToggler ) {
            offcanvasMenuMobile.addEventListener('hide.bs.offcanvas', () => {
                wrapperMenuToggler.classList.toggle('open');
            });
        
            offcanvasMenuMobile.addEventListener('show.bs.offcanvas', () => {
                wrapperMenuToggler.classList.toggle('open');
            });
        }
    });

    /**
     * handle mobile navbar
     */
    function handleMobileNavbar() {
        var { matches } = window.matchMedia("(max-width: 992px)");
        var dropdownTogglers = $('#main-menu--mobile li>.dropdown-toggle');
        if(dropdownTogglers.length > 0 && matches) {

            dropdownTogglers.each(function(i, e) {
                $(e).on('click', function() {
                    $('body').addClass('translate');
                });
            });

            // https://stackoverflow.com/questions/55120954/avoid-dropdown-close-on-clicking-outside
            $(document).on('hide.bs.dropdown', function (e) {
                if ( !$(e.clickEvent.target).parent().hasClass('menu-item--back') && $('.navbar-toggler svg').hasClass('active') ) {
                    e.preventDefault();
                } else {
                    $('body').removeClass('translate');
                }
            });
        }
    }

    handleMobileNavbar();
    $(window).on('resize', function() {
        handleMobileNavbar();
    });

    // Get the button:
    let toTopBtn = document.getElementById("to-top-btn");

    if( toTopBtn ) {
        window.onscroll = function() {
            scrollFunction()
        };

        function scrollFunction() {
            if (document.body.scrollTop > 300 || document.documentElement.scrollTop > 300) {
                toTopBtn.classList.add('to-top-btn--scrolled');
            } else {
                toTopBtn.classList.remove('to-top-btn--scrolled');
            }
        }

        toTopBtn.addEventListener('click', function () {
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        });
    }

    /**
     * Handle team popup
     */

    const $modalTogglers = $('[data-team-id]'),
        $modalBodyContent = $('#teamModal .modal-body-content'),
        modal = document.getElementById('teamModal');

    if( $modalTogglers.length && modal && apiEndpoint?.getTeamMemberUrl ) {
        $modalTogglers.on('click', function() {
            const teamId = $(this).attr('data-team-id');

            const options = {
                method: 'POST',
                body: JSON.stringify({ team_id: teamId }),
                headers: {
                    'Content-type': 'application/json'
                },
                mode: 'cors',
                cache: 'default'
            }
            
            fetch(apiEndpoint.getTeamMemberUrl, options).then(function(response) {
                return response.json();
            }).then(function(data) {
                if(data?.html) {
                    $modalBodyContent.html( data.html );
                    $('#teamModal .modal-body').addClass('modal-body--loaded');
                }

                $('#teamModal .modal-title').text( data.modalTitle );
            }).catch(function (error) {
                console.warn(error);
            });

        });

        modal.addEventListener('hidden.bs.modal', function() {
            $modalBodyContent.empty();
            $('#teamModal .modal-title').empty();
            $('#teamModal .modal-body').removeClass('modal-body--loaded');
        });
    }

})(jQuery, apiEndpoint)